<template>
  <div class="app-container">
    <!-- 考试列表 -->
    <div v-if="!selectedExam" class="exam-list-container">
      <el-card class="exam-list-card">
        <div slot="header">
          <span>选择要分析的考试</span>
        </div>

        <!-- 搜索框 -->
        <el-form :inline="true" class="search-form">
          <el-form-item label="考试名称">
            <el-input v-model="searchTitle" placeholder="请输入考试名称" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchExams">查询</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>

         <!-- 考试列表表格 -->
        <el-table
          :data="examList.records"
          border
          fit
          highlight-current-row
          :header-cell-style="{
            background: '#f2f3f4',
            color: '#555',
            'font-weight': 'bold',
            'line-height': '32px',
          }"
        >
          <el-table-column label="序号" align="center" width="80">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="title" align="center" label="考试名称" />
          <el-table-column prop="passedScore" align="center" label="及格分" />
          <el-table-column prop="grossScore" align="center" label="总分" />
          <el-table-column prop="examDuration" align="center" label="考试时长（分钟）" />
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="{ row }">
              <el-button
                type="primary"
                size="small"
                @click="selectExam(row)"
              >分析</el-button>
            </template>
          </el-table-column>
        </el-table>

         <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            :current-page="examList.current"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="examList.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="examList.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
       </el-card>
     </div>

     <!-- 考试分析详情 -->
     <div v-if="selectedExam" class="analysis-container">
       <!-- 返回按钮 -->
       <div class="back-button-container">
         <el-button @click="backToList" icon="el-icon-back">返回考试列表</el-button>
       </div>

       <!-- 考试基本信息 -->
      <el-card class="exam-info-card">
        <div slot="header">
          <span>{{ selectedExam.title }} - 考试分析</span>
          <div class="header-buttons">
            <el-button type="success" size="small" @click="refreshAnalysis">刷新数据</el-button>
            <el-button type="primary" size="small" @click="exportReport">导出报告</el-button>
          </div>
         </div>

         <el-row :gutter="20" v-if="analysisData">
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">参与人数</div>
              <div class="info-value">{{ analysisData.statistics.totalStudents }}人</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">完成人数</div>
              <div class="info-value">{{ analysisData.statistics.completedStudents }}人</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">平均分</div>
              <div class="info-value">{{ analysisData.statistics.avgScore }}分</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">及格率</div>
              <div class="info-value">{{ (analysisData.statistics.passRate * 100).toFixed(1) }}%</div>
            </div>
          </el-col>
        </el-row>

         <el-row :gutter="20" v-if="analysisData" style="margin-top: 20px;">
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">最高分</div>
              <div class="info-value">{{ analysisData.statistics.maxScore }}分</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">最低分</div>
              <div class="info-value">{{ analysisData.statistics.minScore }}分</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">优秀率</div>
              <div class="info-value">{{ (analysisData.statistics.excellentRate * 100).toFixed(1) }}%</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">总题数</div>
              <div class="info-value">{{ selectedExam.radioCount + selectedExam.multiCount + selectedExam.judgeCount + selectedExam.saqCount }}题</div>
            </div>
          </el-col>
        </el-row>
      </el-card>

       <!-- 统计图表 -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="12">
          <el-card>
            <div slot="header">分数分布</div>
            <div id="scoreChart" style="height: 300px;"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card>
            <div slot="header">时间分布</div>
            <div id="timeChart" style="height: 300px;"></div>
          </el-card>
        </el-col>
      </el-row>

       <!-- 题目分析 -->
      <el-card style="margin-top: 20px;">
        <div slot="header">
          <span>题目分析</span>
        </div>

         <el-table
          :data="analysisData ? analysisData.questionAnalyses : []"
          border
          fit
          :header-cell-style="{
            background: '#f2f3f4',
            color: '#555',
            'font-weight': 'bold',
            'line-height': '32px',
          }"
        >
          <el-table-column label="题号" align="center" width="80">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="questionTitle" label="题目" show-overflow-tooltip />
          <el-table-column prop="questionTypeName" align="center" label="题型" width="100" />
          <el-table-column align="center" label="正确率" width="120">
            <template slot-scope="scope">
              <el-tag :type="getCorrectRateType(scope.row.correctRate)">
                {{ (scope.row.correctRate * 100).toFixed(1) }}%
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="totalAnswers" align="center" label="答题人数" width="100" />
          <el-table-column prop="correctAnswers" align="center" label="正确人数" width="100" />
          <el-table-column prop="wrongAnswers" align="center" label="错误人数" width="100" />
          <el-table-column align="center" label="操作" width="120">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="small"
                @click="viewQuestionDetail(row)"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
     </div>

     <!-- 题目详情对话框 -->
    <el-dialog
      :title="'题目详情 - 第' + (currentQuestionIndex + 1) + '题'"
      :visible.sync="questionDetailVisible"
      width="80%"
      :before-close="closeQuestionDetail"
    >
      <div v-if="currentQuestion">
        <!-- 题目内容 -->
        <div class="question-content">
          <h4>题目内容：</h4>
          <div v-html="currentQuestion.questionTitle"></div>
        </div>

        <!-- 选项分析（仅选择题） -->
        <div v-if="currentQuestion.optionAnalyses && currentQuestion.optionAnalyses.length > 0" class="option-analysis">
          <h4>选项分析：</h4>
          <el-table :data="currentQuestion.optionAnalyses" border>
            <el-table-column prop="optionContent" label="选项内容" />
            <el-table-column align="center" label="选择人数" width="120">
              <template slot-scope="scope">
                {{ scope.row.selectedCount }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="选择率" width="120">
              <template slot-scope="scope">
                {{ (scope.row.selectedRate * 100).toFixed(1) }}%
              </template>
            </el-table-column>
            <el-table-column align="center" label="是否正确" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isCorrect ? 'success' : 'danger'">
                  {{ scope.row.isCorrect ? '正确' : '错误' }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 题目解析 -->
        <div v-if="currentQuestion.analysis" class="question-analysis">
          <h4>题目解析：</h4>
          <div v-html="currentQuestion.analysis"></div>
        </div>
      </div>
     </el-dialog>
   </div>
</template>

<script>
import { recordExamPaging } from '@/api/record'
import { getExamAnalysis, generateAnalysisReport } from '@/api/examAnalysis'
import * as echarts from 'echarts'

export default {
  name: 'ExamAnalysis',
  data() {
    return {
      // 考试列表相关
      examList: {
        records: [],
        current: 1,
        size: 10,
        total: 0
      },
      searchTitle: '',
      pageNum: 1,
      pageSize: 10,

       // 分析相关
      selectedExam: null,
      analysisData: null,
      loading: false,

       // 题目详情
      questionDetailVisible: false,
      currentQuestion: null,
      currentQuestionIndex: 0,

       // 图表实例
      scoreChart: null,
      timeChart: null
    }
   },

   created() {
    this.getExamList()
  },

   beforeDestroy() {
    // 销毁图表实例
    if (this.scoreChart) {
      this.scoreChart.dispose()
    }
    if (this.timeChart) {
      this.timeChart.dispose()
    }
  },

   methods: {
    // 获取考试列表
    async getExamList(pageNum = 1, pageSize = 10, examName = '') {
      try {
        const params = {
          pageNum,
          pageSize,
          examName,
          isASC: false
        }
        const res = await recordExamPaging(params)
        this.examList = res.data
      } catch (error) {
        this.$message.error('获取考试列表失败')
        console.error(error)
      }
     },

     // 搜索考试
    searchExams() {
      this.pageNum = 1
      this.getExamList(this.pageNum, this.pageSize, this.searchTitle)
    },

     // 重置搜索
    resetSearch() {
      this.searchTitle = ''
      this.pageNum = 1
      this.getExamList(this.pageNum, this.pageSize)
    },

     // 分页大小改变
    handleSizeChange(val) {
      this.pageSize = val
      this.getExamList(this.pageNum, val, this.searchTitle)
    },

     // 当前页改变
    handleCurrentChange(val) {
      this.pageNum = val
      this.getExamList(val, this.pageSize, this.searchTitle)
    },

     // 选择考试进行分析
    async selectExam(exam) {
      this.selectedExam = exam
      this.loading = true

       try {
        const res = await getExamAnalysis(exam.id)
        this.analysisData = res.data

         // 等待DOM更新后初始化图表
        this.$nextTick(() => {
          this.initCharts()
        })
      } catch (error) {
        this.$message.error('获取考试分析数据失败')
        console.error(error)
      } finally {
        this.loading = false
      }
     },

     // 返回考试列表
    backToList() {
      this.selectedExam = null
      this.analysisData = null

       // 销毁图表实例
      if (this.scoreChart) {
        this.scoreChart.dispose()
        this.scoreChart = null
      }
      if (this.timeChart) {
        this.timeChart.dispose()
        this.timeChart = null
      }
     },

     // 刷新分析数据
    async refreshAnalysis() {
      if (!this.selectedExam) return

       this.loading = true
      try {
        const res = await getExamAnalysis(this.selectedExam.id)
        this.analysisData = res.data

         // 更新图表
        this.$nextTick(() => {
          this.updateCharts()
        })

         this.$message.success('数据刷新成功')
      } catch (error) {
        this.$message.error('刷新数据失败')
        console.error(error)
      } finally {
        this.loading = false
      }
     },

     // 导出报告
    async exportReport() {
      if (!this.selectedExam) return

       try {
        await generateAnalysisReport(this.selectedExam.id)
        this.$message.success('报告生成成功')
      } catch (error) {
        this.$message.error('报告生成失败')
        console.error(error)
      }
     },

     // 查看题目详情
    viewQuestionDetail(question) {
      this.currentQuestion = question
      this.currentQuestionIndex = this.analysisData.questionAnalyses.findIndex(q => q.questionId === question.questionId)
      this.questionDetailVisible = true
    },

     // 关闭题目详情
    closeQuestionDetail() {
      this.questionDetailVisible = false
      this.currentQuestion = null
      this.currentQuestionIndex = 0
    },

     // 获取正确率标签类型
    getCorrectRateType(rate) {
      if (rate >= 0.8) return 'success'
      if (rate >= 0.6) return 'warning'
      return 'danger'
    },

     // 初始化图表
    initCharts() {
      this.initScoreChart()
      this.initTimeChart()
    },

     // 更新图表
    updateCharts() {
      if (this.scoreChart) {
        this.scoreChart.dispose()
      }
      if (this.timeChart) {
        this.timeChart.dispose()
      }
      this.initCharts()
    },

     // 初始化分数分布图表
    initScoreChart() {
      const chartDom = document.getElementById('scoreChart')
      if (!chartDom || !this.analysisData || !this.analysisData.scoreRanges) return

       this.scoreChart = echarts.init(chartDom)

        const option = {
        title: {
          text: '分数分布',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c}人 ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '分数分布',
            type: 'pie',
            radius: '50%',
            data: this.analysisData.scoreRanges.map(item => ({
              value: item.studentCount,
              name: item.scoreRange
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
       }

       this.scoreChart.setOption(option)
    },

     // 初始化时间分布图表
    initTimeChart() {
      const chartDom = document.getElementById('timeChart')
      if (!chartDom || !this.analysisData || !this.analysisData.timeDistributions) return

       this.timeChart = echarts.init(chartDom)

        const option = {
        title: {
          text: '答题时间分布',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['人数', '平均分']
        },
        xAxis: {
          type: 'category',
          data: this.analysisData.timeDistributions.map(item => item.timeRange)
        },
        yAxis: [
          {
            type: 'value',
            name: '人数',
            position: 'left'
          },
          {
            type: 'value',
            name: '平均分',
            position: 'right'
          }
        ],
        series: [
          {
            name: '人数',
            type: 'bar',
            data: this.analysisData.timeDistributions.map(item => item.studentCount)
          },
          {
            name: '平均分',
            type: 'line',
            yAxisIndex: 1,
            data: this.analysisData.timeDistributions.map(item => item.avgScore)
          }
        ]
       }

       this.timeChart.setOption(option)
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.exam-list-card {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.back-button-container {
  margin-bottom: 20px;
}

.exam-info-card .el-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-buttons {
  display: flex;
  gap: 10px;
}

.info-item {
  text-align: center;
  padding: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.info-label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 5px;
}

.info-value {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.question-content {
  margin-bottom: 20px;
}

.option-analysis {
  margin-bottom: 20px;
}

.question-analysis {
  margin-bottom: 20px;
}

.question-content h4,
.option-analysis h4,
.question-analysis h4 {
  color: #303133;
  margin-bottom: 10px;
}

.el-table .cell {
  white-space: nowrap;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .el-col {
    margin-bottom: 10px;
  }

   .header-buttons {
    flex-direction: column;
    gap: 5px;
   }
  }
</style>
